<template>
  <!-- 资质列表 -->
  <div>
    <el-dialog
      title="审批记录"
      :visible.sync="ARdialogVisible"
      width="50%"
      >
      <div class="approval-read-record">
        <div class="detail-react-timeline-read">
          <!--审批记录-->
          <div class="detail-react-timeline">
            <el-timeline v-if="approvalRecordData.length != 0">
              <el-timeline-item
                v-for="(activity, index) in approvalRecordData"
                placement="top"
                :key="index"
                :timestamp="activity.operTimeString"
                :icon="getIconColor(activity, index).icon"
                :color="getIconColor(activity, index).color"
              >
                <!--            :color="activity.color"-->
                <div class="detail-react-timeline-info ccui-clearfix">
                  <div
                    class="detail-react-timeline-info-avatar"
                    v-if="activity.operResultType != '1'"
                  >
                    <img
                      src="http://cccc-uat.obs.cn-north-4.myhuaweicloud.com/BASA_main/null/2021/1/6/22fd1aafbb394d6f8a809ee9f2a0978f.png"
                    />
                  </div>
                  <div class="detail-react-timeline-info-avatar" v-else>
                    <i
                      class="icon-ccui-woman-avatar"
                      v-if="activity.operatorSex === '2'"
                    ></i>
                    <i class="icon-ccui-user" v-else></i>
                  </div>
                  <div class="detail-react-timeline-info-content">
                    <div>
                      <span :title="activity.operatorName">
                        {{ activity.operatorName | overstep }}
                      </span>

                      <span
                        v-if="activity.operResultType == '1'"
                        class="detail-react-timeline-info-apply"
                      >
                        {{ activity.operResultType == "1" ? "(申请人)" : "" }}
                      </span>
                    </div>
                  </div>
                  <div class="detail-react-timeline-info-enterprise">
                    {{ activity.joinOrgName }}
                  </div>
                </div>
                <!-- 0：已提交   1：已审批  2：待审批 -->
                <p
                  v-if="activity.operState == '2'"
                  class="detail-react-timeline-content detail-react-timeline-ml"
                >
                  审批中...
                </p>
                <template v-else>
                  <p
                    v-if="activity.operResultType == '1'"
                    class="detail-react-timeline-content"
                    style="display:flex"
                  >
                    <span class="detail-react-timeline-content-label">说明:</span>
                    <span
                      :class="[isReadClass]"
                      class="detail-react-timeline-content-text"
                      >{{ activity.operOpinion }}</span
                    >
                  </p>
                  <template v-else>
                    <p class="detail-react-timeline-content" style="display:flex">
                      <span class="detail-react-timeline-content-label">结论:</span>
                      <span
                        :style="{ color: operResultColor[activity.operResultType] }"
                        class="detail-react-timeline-content-text"
                        :class="[isReadClass]"
                      >
                        <!--                    {{ activity.operResultType == '2' ? "同意" : "不同意" }}-->
                        {{ activity.operResultName }}
                      </span>
                    </p>
                    <p class="detail-react-timeline-content" style="display:flex">
                      <span class="detail-react-timeline-content-label">意见:</span>
                      <span
                        class="detail-react-timeline-content-text"
                        :class="[isReadClass]"
                        >{{ activity.operOpinion }}</span
                      >
                    </p>
                  </template>
                </template>
              </el-timeline-item>
            </el-timeline>
            <el-timeline v-if="approvalRecordData.length == 0">
              <div class="detail-react-timeline-tit">暂无数据</div>
            </el-timeline>
          </div>
        </div>
      </div>
       <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { formatDate } from "@/utils";
import {
  queryApprovalRecord
} from "@/api/subcontractor-register";
export default {
  name: "approval-read-record",
  components: {
  },
  props: {
    businessBillId: {
      type: String,
      default: ""
    },
  },
  data() {
    return {
      ARdialogVisible: false,
      approvalRecordData: [],
      // 审批记录字体颜色
      operResultColor: {
        11: "#D5090B", //11:审批中(预留)
        10: "#D5090B", //10:业务单据删除
        9: "#D5090B", //9:退回申请人
        8: "#009588", //8:编辑
        7: "#D5090B", //7:业务端撤回
        6: "#009588", //6:转审
        5: "#009588", //5:协办
        4: "#D5090B", //4:不同意
        3: "#D5090B", //3:退回
        2: "#009588", //2:同意
        1: "#009588", //1:提交(申请人)
        0: "#D5090B" //0 无
      },
      isReadClass: "readClass",
      dialogEdit: false
    };
  },
  watch: {
    approvalRecordData: {
      handler() {
        setTimeout(() => {
          console.log(this.approvalRecordData);
          if (this.approvalRecordData.length !== 0) {
            let id = this.approvalRecordData[this.approvalRecordData.length - 1]
              .taskId;
            let ProcessInstId = this.approvalRecordData[
              this.approvalRecordData.length - 1
            ].procInstId;
          }
        }, 300);
      },
      deep: true,
      immediate: true
    }
  },
  filters: {
    overstep(value) {
      return value.length <= 5 ? value : value.substr(0, 12) + "...";
    }
  },
  mounted() {
    this.getRecordData();
  },
  methods: {
    getRecordData() {
      let params = {
        businessBillId: this.businessBillId,
        businessCode: "S07",
        businessBillType: "S0701",
        businessAppId: 100065
      }
      queryApprovalRecord(params).then(res => {
        this.approvalRecordData = res.data.data.recordList
      })
    },
    dateFormat(value) {
      return value ? formatDate(value, "yyyy-MM-dd HH:mm") : "";
    },
    getIconColor(item, index) {
      if (index == this.approvalRecordData.length - 1) {
        if (
          item.operResultType == "6" ||
          item.operResultType == "5" ||
          item.operResultType == 11
        ) {
          return {
            icon: "icon-ccui-clock",
            color: "rgb(245, 166, 35)"
          };
        } else if (item.operResultType == "2") {
          return {
            icon: "icon-ccui-check",
            color: "rgb(11, 189, 135)"
          };
        } else if (
          item.operResultType == "9" ||
          item.operResultType == "3" ||
          item.operResultType == "4"
        ) {
          return {
            icon: "icon-ccui-warn",
            color: "rgb(212, 10, 10)"
          };
        } else {
          return {};
        }
      } else {
        return {};
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/config/styles/variables";
.clear {
  width: 100%;
  height: 15px;
  background: #f1f1f1;
}
.approval-read-record {
  width: 480px;
  float: left;
  background: #fff;

  .detail-react-title {
    margin: 20px 20px 0;

    .el-button--medium {
      padding: 0 0 3px 0;
      font-size: 14px;
      color: #9b9b9b;

      &.active {
        color: $--color-rest;
        border-bottom: 2px solid $--color-rest;
        border-radius: 0;
        font-weight: 600;
        font-size: 14px;
      }
    }

    .processed {
      margin-left: 23px;
    }
  }

  .detail-react-timeline-read {
    /deep/ .opinionSize {
      margin-top: 0 !important;
    }

    .detail-react-read {
      padding: 20px;
    }

    .detail-react-timeline {
      padding: 20px;
      /deep/ .el-timeline-item:last-child .el-timeline-item__node--normal {
        width: 16px;
        height: 16px;
        left: -3px;
      }
      /deep/ .el-timeline-item {
        &:not(:last-child) {
          padding-bottom: 40px;
        }

        &:last-child {
          padding-bottom: 0px;
        }

        .el-timeline-item__timestamp {
          position: absolute;
          right: 0;
          font-size: 12px;
        }

        .el-timeline-item__tail {
          top: 5px;
        }

        .el-timeline-item__node {
          top: 5px;
        }

        .el-timeline-item__icon {
          font-size: 15px;
        }
      }

      .detail-react-timeline-info {
        .detail-react-timeline-info-avatar {
          width: 30px;
          height: 30px;
          background-color: #5daaff;
          border-radius: 50%;
          float: left;
          margin-right: 7px;
          position: relative;

          img {
            width: 100%;
            height: 100%;
          }

          i {
            font-size: 26px;
            color: #fff;
            position: absolute;
            left: 2.3px;
            bottom: -1px;
          }
        }

        .detail-react-timeline-info-content {
          font-size: 13px;
          font-weight: 500;
          padding-right: 120px;

          .detail-react-timeline-info-apply {
            margin-left: 6px;
            color: #9b9b9b;
          }
        }

        .detail-react-timeline-info-enterprise {
          font-size: 12px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: #9b9b9b;
          line-height: 17px;
        }
      }

      .detail-react-timeline-content {
        margin-top: 6px;
        font-size: 13px;

        &.detail-react-timeline-ml {
          margin-left: 37px;
        }

        .detail-react-timeline-content-label {
          width: 32px;
          color: #9b9b9b;
          margin-right: 7px;
        }
      }

      .detail-react-timeline-content-text {
        // word-break: break-all;
        // white-space: pre-wrap;
        // white-space: -moz-pre-wrap;
        // white-space: -pre-wrap;
        // white-space: -o-pre-wrap;
        // word-wrap: break-word;
      }
    }
  }
}

.readClass {
  display: block;
  word-break: break-all;
  width: 275px;
}
.detail-react-timeline-tit {
  text-align: center;
  font-size: 14px;
  color: #9b9b9b;
}
</style>
